import * as React from 'react';
const SvgElixiaPrideLight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={120} height={29} fill="none">
    <path
      fill="url(#elixia-pride-light_svg__a)"
      d="M92.42 13.766c8.408 0 15.107 6.586 15.107 14.57q0 .183-.006.373h2.135l.005-.374c-.001-9.08-7.48-16.468-16.796-16.696l-.444-.006q-.763 0-1.51.063v2.142q.745-.072 1.51-.072"
    />
    <path
      fill="url(#elixia-pride-light_svg__b)"
      d="M92.421 11.635c9.547 0 17.17 7.48 17.17 16.568q0 .254-.007.505h2.134l.001-.022.006-.483c-.001-10.167-8.375-18.44-18.805-18.695l-.499-.006a20 20 0 0 0-1.51.056v2.14q.747-.063 1.51-.063"
    />
    <path
      fill="url(#elixia-pride-light_svg__c)"
      d="M92.421 9.504c10.687 0 19.233 8.376 19.234 18.567q0 .318-.011.634h2.134l.003-.1.008-.534c-.001-11.254-9.271-20.41-20.816-20.694l-.552-.007c-.514 0-1.002.006-1.507.04V9.55c.504-.038.993-.045 1.507-.045"
    />
    <path
      fill="url(#elixia-pride-light_svg__d)"
      d="M92.42 7.372c11.827 0 21.298 9.272 21.298 20.567q0 .383-.014.762h2.134l.006-.176.008-.586c0-12.34-10.165-22.382-22.826-22.692l-.605-.008q-.765 0-1.517.047l.006 2.14c.5-.033 1-.054 1.51-.054"
    />
    <path
      fill="url(#elixia-pride-light_svg__e)"
      d="M92.421 5.24c12.966 0 23.362 10.167 23.362 22.567q0 .45-.019.896h2.135l.008-.258.009-.638c0-13.428-11.061-24.354-24.837-24.692l-.658-.008c-.513 0-1.018.016-1.524.045l.009 2.132a24 24 0 0 1 1.515-.043"
    />
    <path
      fill="url(#elixia-pride-light_svg__f)"
      d="M92.421 3.106c14.106 0 25.425 11.198 25.425 24.701q0 .45-.017.895h2.135l.006-.205.01-.69c0-14.515-11.957-26.46-26.848-26.825l-.71-.009c-.51 0-1.02.005-1.523.031v2.137a27 27 0 0 1 1.522-.035"
    />
    <path
      fill="#fff"
      d="M20.465 11.362h-9.116l-.992 3.39h6.781l-1.44 5.054h-6.78l-1.12 3.839h9.532l-1.44 5.053H.602l6.43-22.39h14.873zM18.562 28.698l6.43-22.39h5.757l-4.99 17.337h8.892l-1.471 5.053zM35.711 28.698l6.43-22.39h5.757l-6.43 22.39zM70.575 6.308l-10.14 11.58 3.775 10.81h-5.886l-2.207-6.78-5.693 6.78h-6.75l10.332-11.77-3.774-10.62h5.885l2.207 6.59 5.502-6.59zM66.26 28.698l6.43-22.39h5.757l-6.43 22.39zM87.434 6.308h7.709v22.39H89.96v-4.542h-7.26l-2.528 4.542H74zm-1.887 12.795h4.414V11.17z"
    />
    <defs>
      <linearGradient
        id="elixia-pride-light_svg__a"
        x1={90.912}
        x2={99.997}
        y1={20.429}
        y2={20.429}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#502E91" stopOpacity={0} />
        <stop offset={1} stopColor="#502E91" />
      </linearGradient>
      <linearGradient
        id="elixia-pride-light_svg__b"
        x1={90.912}
        x2={99.969}
        y1={19.298}
        y2={19.298}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#336FE2" stopOpacity={0} />
        <stop offset={1} stopColor="#336FE2" />
      </linearGradient>
      <linearGradient
        id="elixia-pride-light_svg__c"
        x1={90.914}
        x2={100.948}
        y1={18.168}
        y2={18.168}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#55A17B" stopOpacity={0} />
        <stop offset={1} stopColor="#55A17B" />
      </linearGradient>
      <linearGradient
        id="elixia-pride-light_svg__d"
        x1={90.904}
        x2={99.969}
        y1={17.036}
        y2={17.036}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC100" stopOpacity={0} />
        <stop offset={1} stopColor="#FFC100" />
      </linearGradient>
      <linearGradient
        id="elixia-pride-light_svg__e"
        x1={90.897}
        x2={100.025}
        y1={15.905}
        y2={15.905}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF621D" stopOpacity={0} />
        <stop offset={1} stopColor="#FF621D" />
      </linearGradient>
      <linearGradient
        id="elixia-pride-light_svg__f"
        x1={90.899}
        x2={99.998}
        y1={14.905}
        y2={14.905}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2102A" stopOpacity={0} />
        <stop offset={1} stopColor="#C2102A" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgElixiaPrideLight;
